import { render } from "./Header.vue?vue&type=template&id=0727ec49&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=0727ec49&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/marlu-store-locator-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__